import type { AysCodeCodingSystem } from '@bindoc-projects/code-domain-lib';
import { AysCode } from '@bindoc-projects/code-domain-lib';
import type { HtmCodeGroupId } from './code-group';

export interface HtmCodeGroup {
  id: HtmCodeGroupId;
  displayName: string;
  codes: AysCode[];
  codingSystem: AysCodeCodingSystem;
}

/**
 * Watch out for the order of this
 */
export const HTM_CODE_GROUPS: HtmCodeGroup[] = [
  /*{
    id: null,
    displayName: 'MRE',
    codes: [
      AysCode.of('8-987.0', 'OPS'),
      AysCode.of('8-987.00', 'OPS'),
      AysCode.of('8-987.01', 'OPS'),
      AysCode.of('8-987.02', 'OPS'),
      AysCode.of('8-987.03', 'OPS'),
      AysCode.of('8-987.1', 'OPS'),
      AysCode.of('8-987.10', 'OPS'),
      AysCode.of('8-987.11', 'OPS'),
      AysCode.of('8-987.12', 'OPS'),
      AysCode.of('8-987.13', 'OPS'),
    ],
    codeType: 'OPS'
  },*/
  {
    id: 'sonstige-sepsis',
    displayName: 'Sepsis',
    codes: [
      new AysCode('A41.0', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A41.1', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A41.2', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A41.3', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A41.4', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A41.5', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A41.51', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A41.52', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A41.58', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A41.8', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A41.9', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('R65.0', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('R65.1', undefined, 'ICD-10-GM', 'specific'),
    ],
    codingSystem: 'ICD-10-GM',
  },
  {
    id: 'clostridioides-difficile',
    displayName: 'Clostridioides difficile',
    codes: [
      new AysCode('A04.7', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A04.70', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A04.71', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A04.72', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A04.73', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('A04.79', undefined, 'ICD-10-GM', 'specific'),
    ],
    codingSystem: 'ICD-10-GM',
  },
  {
    id: 'harnwegsinfektion',
    displayName: 'Infektion des Harnsystems',
    codes: [
      new AysCode('N30.0', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('N39.0', undefined, 'ICD-10-GM', 'specific'),
    ],
    codingSystem: 'ICD-10-GM',
  },
  {
    id: 'infektion-nach-eingriff',
    displayName: 'Infektionen nach Eingriffen',
    codes: [
      new AysCode('T80.2', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('T81.4', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('T83.5', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('T87.4', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.0', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.1', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.2', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.3', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.4', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.5', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.6', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.8', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.9', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.00', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.01', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.02', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.03', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.04', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.05', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.06', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.07', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.08', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.09', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.10', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.11', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.12', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.13', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.14', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.15', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.16', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.17', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.18', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.19', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.20', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.21', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.22', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.23', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.24', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.25', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.26', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.27', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.28', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.29', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.30', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.31', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.32', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.33', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.34', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.35', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.36', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.37', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.38', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.39', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.40', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.41', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.42', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.43', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.44', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.45', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.46', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.47', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.48', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.49', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.50', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.51', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.52', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.53', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.54', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.55', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.56', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.57', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.58', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.59', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.60', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.61', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.62', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.63', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.64', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.65', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.66', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.67', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.68', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.69', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.80', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.81', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.82', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.83', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.84', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.85', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.86', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.87', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.88', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.89', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.90', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.91', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.92', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.93', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.94', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.95', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.96', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.97', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.98', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('M86.99', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('L03', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('L03.0', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('L03.01', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('L03.02', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('L03.1', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('L03.10', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('L03.11', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('L03.2', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('L03.3', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('L03.8', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('L03.9', undefined, 'ICD-10-GM', 'specific'),
    ],
    codingSystem: 'ICD-10-GM',
  },
  {
    id: 'pneumonie',
    displayName: 'Pneumonie',
    codes: [
      new AysCode('J13', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J14', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J15', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J15.0', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J15.1', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J15.2', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J15.3', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J15.4', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J15.5', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J15.6', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J15.7', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J15.8', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J15.9', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J16', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J16.0', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J16.8', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J18', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J18.0', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J18.1', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J18.2', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J18.8', undefined, 'ICD-10-GM', 'specific'),
      new AysCode('J18.9', undefined, 'ICD-10-GM', 'specific'),
    ],
    codingSystem: 'ICD-10-GM',
  },
];
